import blacklist from '../public/blacklist.json'

export const EXCLUDED_ADDRESSES = blacklist as string[]
